<template>
<div>
  <el-row class="title-bar vertical-center-box" type="flex" justify="space-between">
    <div class="title-h4">관리 대상</div>
    <w-search-field ref="treeSearchField" width="200px" @search="filterTree" />
  </el-row>
  <hr class="mr-b10"/>
  <el-tree ref="targetObjTree" v-if="showCheckBoxFlag === true" class="tree-checkbox" show-checkbox :data="objTreeData" :default-expand-all="true" :expand-on-click-node="false" :props="defaultProps" :node-key="defaultProps.treeKey" :filter-node-method="filterNode" @node-click="onClickNode">
    <span class="el-tree-node__label" slot-scope="{ node, data }">
      <span>{{isObjNode(data) && isRequireIPObjType(data) ? getObjNodeLabel(data) : data.label}}</span>
    </span>
  </el-tree>
  <el-tree ref="targetObjTree" v-else :data="objTreeData" :default-expand-all="true" :expand-on-click-node="false" :props="defaultProps" :node-key="defaultProps.treeKey" :filter-node-method="filterNode" @node-click="onClickNode">
    <span class="el-tree-node__label" slot-scope="{ node, data }">
      <span>{{isObjNode(data) && isRequireIPObjType(data) ? getObjNodeLabel(data) : data.label}}</span>
    </span>
  </el-tree>
</div>
</template>

<script>
import EventPredictSettingsAPI from '@/api/settings/common/event-predict-settings';
import { isEmpty, isNil } from 'lodash';
import { defaultProps } from '@/constants/tree';
import msgUtil from '@/utils/message';
import TreeFilter from '@/mixins/tree/filter';
import WSearchField from '@/components/form/SearchField';
import { findFirstLeafTreeKey, getPathNodes, isObjNode, isRequireIPObjType, getObjNodeLabel } from '@/utils/tree';

export default {
  name: 'WPredictTargetObjTree',
  components: {
    WSearchField,
  },
  mixins: [TreeFilter],
  props: {
    /**
     * leaf 노드만 선택되도록 한다.
     * @type {Boolean}
     */
    forceSelectLeaf: {
      type: Boolean,
      default: false,
    },
    showCheckBoxFlag: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      defaultProps,
      loading: false,
      objTreeData: [],
      selectedNode: null,
    };
  },
  methods: {
    isObjNode,
    isRequireIPObjType,
    getObjNodeLabel,
    /**
     * 이벤트 예측 자원으로 설정된 관리 대상 트리를 조회한다.
     * @author yelim
     */
    loadData(params) {
      // objtypeId가 파라미터로 넘어오는지 아닌지 확인
      let settingsParam = {};
      if (!isNil(params)) {
        settingsParam = isNil(params.objDefineId) ? { isThresholdFlag: params.isThresholdFlag } : { objDefineId: params.objDefineId };
      }
      this.loading = true;
      EventPredictSettingsAPI.getPredictTargetObjTree(settingsParam)
        .then((response) => {
          if (response.data.success) {
            this.objTreeData = [response.data.children];
            this.$nextTick(() => {
              let selectedNode;
              const root = this.$refs.targetObjTree.getNode(response.data.children.treeKey);
              if (!isEmpty(this.selectedNode)) {
                selectedNode = this.$refs.targetObjTree.getNode(this.selectedNode.treeKey);
              }

              if (isEmpty(selectedNode)) {
                if (this.forceSelectLeaf === true) {
                  const treeKey = findFirstLeafTreeKey(root);
                  if (treeKey === null) {
                    selectedNode = root;
                  } else {
                    selectedNode = this.$refs.targetObjTree.getNode(treeKey) || root;
                  }
                } else {
                  selectedNode = root;
                }
              }

              if (!isEmpty(selectedNode)) {
                const pathNodes = getPathNodes(selectedNode);
                pathNodes.forEach((item) => {
                  if (!item.isLeaf) {
                    item.expanded = true;
                  }
                });
                this.setSelectedNode(selectedNode);
                this.$refs.targetObjTree.setCurrentKey(selectedNode.data.treeKey);
              }
            });
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '관리 대상 정보', false));
          }
        })
        .catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '관리 대상 정보', false));
          throw new Error(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * 노드 클릭 이벤트 핸들러
     * @author Ju
     * @param  {[type]} data    [description]
     * @param  {[type]} node    [description]
     * @param  {[type]} nodeCmp [description]
     */
    onClickNode(data, node, nodeCmp) {
      if (this.forceSelectLeaf === true) {
        if (node.isLeaf === true) {
          this.setSelectedNode(node);
        } else {
          nodeCmp.$el.blur();
          let selectedNode;
          if (!isEmpty(this.selectedNode)) {
            selectedNode = this.$refs.targetObjTree.getNode(this.selectedNode.treeKey);
          } else {
            const root = this.$refs.targetObjTree.getNode(this.objTreeData[0].treeKey);
            const treeKey = findFirstLeafTreeKey(root);
            selectedNode = this.$refs.targetObjTree.getNode(treeKey);
            this.selectdNode = selectedNode;
          }

          if (!isEmpty(selectedNode)) {
            this.$refs.targetObjTree.setCurrentKey(selectedNode.data.treeKey);
          }
        }
      } else {
        this.setSelectedNode(node);
      }
    },
    /**
     * 선택된 노드를 설정한다.
     * @author Ju
     * @param  {Object} node 트리 노드 객체
     */
    setSelectedNode(node) {
      this.selectedNode = node.data;
      this.$emit('select-node', node.data);
    },
    /**
     * 키워드에 해당하는 노드로 필터링한다.
     * @author Ju
     * @param  {String} value 키워드
     */
    filterTree(value) {
      this.$refs.targetObjTree.filter(value);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/BasicInfoSettings/EventPredictSetting/components/PredictTargetObjTree.vue